import Image from "next/image";
import React from "react";

interface TrendingIconProps {
  direction: "up" | "down";
  className?: string;
  width?: number;
  height?: number;
}

export const TrendingIcon: React.FC<TrendingIconProps> = ({ direction, className, width = 12, height = 12 }) => (
  <Image
    src={direction === "up" ? "/tkn_lnd_pg_assets/images/icons/trending_up.svg" : "/tkn_lnd_pg_assets/images/icons/trending_down.svg"}
    alt={direction}
    width={width}
    height={height}
    className={className}
  />
);
